module.exports = __webpack_public_path__ + "fontawesome-webfont.e57c3d7fa8378d92fa37.woff2";


//////////////////
// WEBPACK FOOTER
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/assets/fonts/fontawesome-webfont.woff2?v=4.6.3
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.woff2?v=4.6.3
// module chunks = styles